/** Shipment detail left column canvas (GPX bg-1, labs-adjacent). */
export const SHIPMENT_DETAIL_COLUMN_BG = '#F1F3F5';

export const shipmentDetailColumnStyle = {
  backgroundColor: SHIPMENT_DETAIL_COLUMN_BG,
};
